import UploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

interface ModalUploadCaseDocumentProps {
	isOpen: boolean;
	onClose: () => void;
	onAttach: (file: File) => void;
}

export const ModalUploadCaseDocument: React.FC<ModalUploadCaseDocumentProps> = ({ isOpen, onClose, onAttach }) => {
	const [selectedFile, setSelectedFile] = useState<File | null>(null);

	useEffect(() => {
		if (!isOpen) setSelectedFile(null);
	}, [isOpen]);

	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files && event.target.files.length > 0) {
			setSelectedFile(event.target.files[0]);
		}
	};

	const handleAttach = () => {
		if (selectedFile) onAttach(selectedFile);
	};

	const formatFileSize = (size: number) => {
		if (size < 1024) return `${size}B`;
		if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)}KB`;
		return `${(size / (1024 * 1024)).toFixed(2)}MB`;
	};

	const handleClose = () => {
		if (document.activeElement instanceof HTMLElement) {
			document.activeElement.blur();
		}
		setTimeout(() => onClose(), 0);
	};

	return (
		<Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
			<DialogTitle>Anexar Documento</DialogTitle>
			<DialogContent>
				{selectedFile ? (
					<Box sx={{ border: "2px dashed #FFD700", borderRadius: 2, p: 4, mt: 1, textAlign: "center" }}>
						<Typography variant="body1" sx={{ wordBreak: "break-word", textAlign: "center" }}>
							{selectedFile.name}
						</Typography>
						<Typography variant="body2" color="text.secondary">
							Tamanho: {formatFileSize(selectedFile.size)}
						</Typography>
						<Button color="error" startIcon={<DeleteIcon />} onClick={() => setSelectedFile(null)}>
							Apagar
						</Button>
					</Box>
				) : (
					<Box
						sx={{ border: "2px dashed #FFD700", borderRadius: 2, p: 4, mt: 1, cursor: "pointer", textAlign: "center" }}
						onClick={() => document.getElementById("upload-case-document-input")?.click()}
					>
						<UploadIcon sx={{ fontSize: 48, color: "#666", mb: 1 }} />
						<Typography variant="body2" color="text.secondary">
							Clique para carregar o arquivo (máx. 50MB)
						</Typography>
					</Box>
				)}

				<input id="upload-case-document-input" type="file" style={{ display: "none" }} onChange={handleFileChange} />
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={handleClose}>Cancelar</Button>
				<Button onClick={handleAttach} disabled={!selectedFile} variant="contained">
					Anexar
				</Button>
			</DialogActions>
		</Dialog>
	);
};
